import { Chip, type ChipProps } from '@mui/material';
import { alpha, lighten } from '@mui/material/styles';

// Deterministic, accessible colour per category name (no hard-coded categories).
const palette = ['#C85A0C', '#1e6fa8', '#2f7d32', '#8a6d00', '#6b4bb7', '#b4232a', '#3d4650', '#0f7a6e'];

function colorFor(name: string) {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return palette[h % palette.length];
}

export function CategoryChip({ name, ...props }: { name: string | null | undefined } & Omit<ChipProps, 'label'>) {
  const label = name || 'No module';
  const color = colorFor(label);
  return (
    <Chip
      size="small"
      label={label}
      variant="outlined"
      sx={[
        { borderColor: color, color, bgcolor: alpha(color, 0.07), maxWidth: '100%' },
        // Lighter text on dark backgrounds so every category stays readable.
        (t) => t.applyStyles('dark', { borderColor: lighten(color, 0.35), color: lighten(color, 0.55), bgcolor: alpha(color, 0.18) }),
      ]}
      {...props}
    />
  );
}
